export default "__VITE_ASSET__DNHsqvpm__"